import React, { useMemo } from 'react'

import { toBase64 } from '../../helpers'
import { COLORS } from '../../styles'

import Styled from './ImageWithBlurryPlaceholder.styled'

const circleSvgElement = (fill = 'none') =>
  `<svg preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="150" cy="150" r="60" fill="${fill}"/></svg>`

const rectangularSvgElement = (fill = 'none') =>
  `<svg preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="300" height="300" fill="${fill}"/></svg>`

const getSvgElement = (fill, shape) => {
  let svgElement = circleSvgElement(fill)
  if (shape === 'rectangular') {
    svgElement = rectangularSvgElement(fill)
  }
  return `data:image/svg+xml;base64,${toBase64(svgElement)}`
}

const ImageWithBlurryPlaceholder = ({
  alt,
  className,
  fill,
  onError,
  onLoad,
  onLoadingComplete,
  placeholderColor,
  priority,
  shape,
  sizes,
  src,
  style,
  title,
}) => {
  const blurDataURL = useMemo(() => {
    return getSvgElement(placeholderColor, shape)
  }, [placeholderColor, shape])

  return (
    <Styled
      alt={alt}
      blurDataURL={blurDataURL}
      className={className}
      fill={fill}
      onError={onError}
      onLoad={onLoad}
      onLoadingComplete={onLoadingComplete}
      placeholder="blur"
      priority={priority}
      quality={100}
      sizes={sizes}
      src={src}
      style={style}
      title={title}
    />
  )
}

ImageWithBlurryPlaceholder.defaultProps = {
  alt: '',
  fill: true,
  placeholderColor: COLORS.white,
}

export default ImageWithBlurryPlaceholder
